export default __webpack_public_path__ + "static/media/IMG_6415.4e294c18.jpeg";